import React from "react";
export default class SVG extends React.Component {
  render() {
    return <svg width="56" height="56" viewBox="0 0 56 56" xmlns="http://www.w3.org/2000/svg" {...this.props}><g fill="#FFF" fillRule="evenodd"><path d="M28 53c13.807 0 25-11.193 25-25S41.807 3 28 3 3 14.193 3 28s11.193 25 25 25zm0 3C12.536 56 0 43.464 0 28S12.536 0 28 0s28 12.536 28 28-12.536 28-28 28z" /><path d="M37.232 27.91L22 36.82V19z" /></g></svg>;
  }

}